import { useState, useContext, useEffect, useMemo } from "react";
import { read, utils } from "xlsx";
import { TimetablesContext } from "../../contexts/timetablesContext";
import { DateDisplay } from "./DateDisplay";
import { SalahTimes } from "./SalahTimes";

export const Timetable = () => {
  const { data, loading } = useContext(TimetablesContext);
  const timetables = !loading && data && data.allTimetable;

  const [todaysData, setTodaysData] = useState({});
  const [pdfURL, setPdfURL] = useState('');
  const [jummahTimes, setJummahTimes] = useState([]);

  const { dayOfMonth, timetableName } = useMemo(() => {
    const today = new Date();
    return {
      dayOfMonth: String(today.getDate()),
      timetableName: new Intl.DateTimeFormat("en-UK", {
        month: "long",
        year: "numeric"
      }).format(today)
    };
  }, []);

  useEffect(() => {
    if (timetables) {
      const result = timetables.find((obj) => obj.title === timetableName);
      if (!result) return;

      const url = result.excel_file.asset.url;
      setJummahTimes([result.jummah_1, result.jummah_2, result.jummah_3]);
      setPdfURL(result.pdf_file.asset.url);

      const req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function () {
        const data = new Uint8Array(req.response);
        const wb = read(data, { type: "array" });
        const ws = wb.Sheets["Sheet1"];
        const datas = utils.sheet_to_json(ws, { raw: false });
        setTodaysData(datas[parseInt(dayOfMonth) - 1]);
      };
      req.send();
    }
  }, [timetables, timetableName, dayOfMonth]);

  return (
    <div className="m-mainCallToAction">
      <DateDisplay pdfURL={pdfURL} />
      <SalahTimes todaysData={todaysData} jummahTimes={jummahTimes} />
    </div>
  );
};
